/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientIdent as AgentApiContractClientIdent } from '../../models/AgentApi/Contract/client-ident';
import { ClientIdentRequest as AgentApiContractClientIdentRequest } from '../../models/AgentApi/Contract/client-ident-request';

export interface ApiAgentGetClientIdentPost$Params {
  lang?: string;
      body?: AgentApiContractClientIdentRequest
}

export function apiAgentGetClientIdentPost(http: HttpClient, rootUrl: string, params?: ApiAgentGetClientIdentPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractClientIdent>> {
  const rb = new RequestBuilder(rootUrl, apiAgentGetClientIdentPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractClientIdent>;
    })
  );
}

apiAgentGetClientIdentPost.PATH = '/api/Agent/GetClientIdent';
